<template>
    <div class="noah-aura-container">
     <div class="ai-logo">NOAH<span style="font-weight: 600; animation: colorChangeTwo 5s ease infinite;">AURA</span> </div>
  
      <p class="intro">{{ $t('noahai.aura_info.intro') }}</p>
  
      <section class="section">  
        <img class="ai-icon" src="@/assets/icon/noahai.svg" :alt="$t('noahai.aura_info.ai_icon_alt')"  />
        <p>
          <span v-html="$t('noahai.aura_info.section_overview_html')"></span>
          <br> <br>{{ $t('noahai.aura_info.section_overview_p2') }}
        </p>
      </section>
  
      <section class="section">
        <h3><img class="head-icon" src="@/assets/icon/head.svg" />{{ $t('noahai.aura_info.section_features_title') }}</h3>
        <ul>
          <li v-for="(item, idx) in $tm('noahai.aura_info.section_features_bullets')" :key="idx">{{ item }}</li>
        </ul>
      </section>
  
      <section class="section">
        <h3><img class="head-icon" src="@/assets/icon/head.svg" />{{ $t('noahai.aura_info.section_tech_title') }}</h3>
        <p>{{ $t('noahai.aura_info.section_tech_p') }}</p>
        <ul>
          <li><strong>{{ $t('noahai.aura_info.section_tech_bullet_source_label') }}</strong> {{ $t('noahai.aura_info.section_tech_bullet_source_text') }}</li>
          <li><strong>{{ $t('noahai.aura_info.section_tech_bullet_method_label') }}</strong> {{ $t('noahai.aura_info.section_tech_bullet_method_text') }}</li>
          <li><strong>{{ $t('noahai.aura_info.section_tech_bullet_dataset_label') }}</strong> {{ $t('noahai.aura_info.section_tech_bullet_dataset_text') }}</li>
        </ul>
      </section>
  
      <section class="section">
        <h3><img class="head-icon" src="@/assets/icon/head.svg" />{{ $t('noahai.aura_info.section_usecases_title') }}</h3>
        <ul>
          <li v-for="(item, idx) in $tm('noahai.aura_info.section_usecases_bullets')" :key="idx">{{ item }}</li>
        </ul>
      </section>
  
      <section class="section">
        <h3><img class="head-icon" src="@/assets/icon/head.svg" />{{ $t('noahai.aura_info.section_infra_title') }}</h3>
        <p>{{ $t('noahai.aura_info.section_infra_intro') }}</p>
        <ul>
          <li><strong>{{ $t('noahai.aura_info.section_infra_bullet1_label') }}</strong> {{ $t('noahai.aura_info.section_infra_bullet1_text') }}</li>
          <li><strong>{{ $t('noahai.aura_info.section_infra_bullet2_label') }}</strong> {{ $t('noahai.aura_info.section_infra_bullet2_text') }}</li>
          <li><strong>{{ $t('noahai.aura_info.section_infra_bullet3_label') }}</strong> {{ $t('noahai.aura_info.section_infra_bullet3_text') }}</li>
        </ul>
      </section>
  
      <section class="section">
        <h3><img class="head-icon" src="@/assets/icon/head.svg" />{{ $t('noahai.aura_info.section_how_title') }}</h3>
        <ol>
          <li v-for="(item, idx) in $tm('noahai.aura_info.section_how_steps')" :key="idx">{{ item }}</li>
        </ol>
      </section>
  
      <div style="text-align: center; margin: 2rem 0;"> 
        <router-link to="/kullanim-kilavuzu" class="info-link"><img class="icon" src="@/assets/icon/klavuz.svg" :alt="$t('noahai.aura_info.guide_icon_alt')"  /> <br> {{ $t('noahai.aura_info.guide_cta') }}</router-link></div>
  
      <footer>
        <p>{{ $t('noahai.aura_info.footer') }}</p>
      </footer>
    </div>
  </template>
  
  <script>
  export default {
    name: "NoahAuraInfo",
  };
  </script>
  
  <style scoped>
  .noah-aura-container {
    padding: 1em; 
  }

  .ai-logo {
    font-size: 2rem;
    font-weight: 200;
  }

  .ai-icon {
    max-width: 10rem; opacity: 0.5;
  }
   
  h3 { display: flex;
    align-items: center;
    gap: 5px;
    font-weight: 300;
    font-size: 1rem;
  }
  .head-icon{ min-width: 1.5rem; max-width: 3rem; }
  .intro, .section p, ul, ol {
    line-height: 1.6;
  }
  
  .section {
    margin-top: 2rem;
  }
  
  .info-link {
    color: #086b68;
    text-decoration: none;
    text-align: center;
    font-weight: 400; font-size: 1rem;
  }
  .icon{max-width: 3rem;}
  footer {
    text-align: center;
    opacity: 0.8;
    margin-top: 2rem;
  } 

  ul {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    gap: 1em;
  }
  li {
    margin: 0;
    list-style: none;
    padding: 2em;
    border-radius: 0.5em;
    background: linear-gradient(45deg, #040404, #011111, #040404); 
    border: 1px solid #011111;

  }
  </style>